export default __webpack_public_path__ + "static/media/logo_naranjo_fondo.e1f80266.png";